/**
 * Returns the appropriate locale for documentation links.
 * Documentation only supports EN, ES, and PT. For all other locales, fallback to English.
 *
 * @param {string} locale - The current locale
 * @returns {string} - The documentation locale (en, es, pt) or 'en' as fallback
 */
export const getDocumentationLocale = locale => {
  // Documentation supported locales
  const supportedLocales = ['en', 'es', 'pt']

  // Return the locale if it's supported, otherwise fallback to English
  return supportedLocales.includes(locale) ? locale : 'en'
}
